export const FOLLOW_UP_ACTIONS_CHANGED = 'FOLLOW_UP_ACTIONS_CHANGED';

export const FOLLOW_UP_ACTION_QUEUES = Object.freeze([
  { value: 'active', text: 'My Actions', description: 'Accepted and self-assigned actions that are Pending or In Progress.' },
  { value: 'incoming', text: 'Incoming', description: 'Review assignments and accept them into My Actions or return them to the assigner.' },
  { value: 'sent', text: 'Sent', description: 'Track the response and progress of actions you assigned to others.' },
  { value: 'rejected', text: 'Rejected', description: 'Review returned actions and choose a new owner or assign them to yourself.' },
  { value: 'history', text: 'History', description: 'Completed and cancelled actions you own or assigned to others.' }
]);

export const FOLLOW_UP_ACTION_PRIORITY_OPTIONS = Object.freeze([
  { id: 'low', name: 'Low' },
  { id: 'medium', name: 'Medium' },
  { id: 'high', name: 'High' },
  { id: 'urgent', name: 'Urgent' }
]);
